import { POST, GET, UPDATE } from 'src/api/apiHandler';
import {
  PRODUCT,
  PRODUCT_SEARCH,
  PRODUCT_MASTER_SEARCH,
  PRODUCT_PAGINATION,
  PRODUCT_DOWNLOAD_RESULTS,
} from 'src/api/routes';
import { API_BASE_URL } from 'src/globals';

function createProduct(product) {
  return POST(`${API_BASE_URL}${PRODUCT}`, product);
}

function editProduct(product) {
  return UPDATE(`${API_BASE_URL}${PRODUCT}`, product);
}

function fetchProducts(params) {
  return GET(`${API_BASE_URL}${PRODUCT}`, params);
}

function fetchProductsPagination(params, signal?: AbortSignal) {
  return GET(`${API_BASE_URL}${PRODUCT_PAGINATION}`, params, undefined, undefined, signal);
}

function searchProduct(params, signal?: AbortSignal) {
  return GET(`${API_BASE_URL}${PRODUCT_SEARCH}`, params, undefined, undefined, signal);
}

function searchProductMaster(params) {
  return GET(`${API_BASE_URL}${PRODUCT_MASTER_SEARCH}`, params);
}

function downloadProducts(params) {
  return GET(`${API_BASE_URL}${PRODUCT_DOWNLOAD_RESULTS}`, params, 'blob');
}

export {
  editProduct,
  searchProduct,
  createProduct,
  fetchProducts,
  searchProductMaster,
  fetchProductsPagination,
  downloadProducts,
};
